import { User } from "oidc-client-ts"
import { useSelector } from "react-redux"
import { getUserProfile } from "@/reducers/userProfile"
import { USER_STORAGE_KEY } from "./odUserManager"
import { AccessTokenClaims } from "./odUserManager"
import { parseAccessToken } from "./jwtDecode"
import { useMemo } from "react"

export const useIsLocalUserWithNoPhone = () => {
  const userProfile = useSelector(getUserProfile)

  const result = useMemo(() => {
    const user = User.fromStorageString(
      window.localStorage.getItem('oidc.' + USER_STORAGE_KEY) ?? '{}'
    )
    if (!user) { return true }
    let isLocalLogin = false
    try {
      const jwtAt = parseAccessToken<AccessTokenClaims>(user.access_token).payload
      isLocalLogin = jwtAt.idp === 'local'
    } catch {
      isLocalLogin = true
    }

    return Boolean(isLocalLogin && !userProfile?.phone)
  }, [userProfile?.phone])

  return result
}